import * as Joi from "joi";
import { Moment } from 'moment';
import { Column } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import { WrapBoxESDoc } from './wrap-box.interfaces';
import { DEPARTMENTS } from '../enums/enums';
import EpisodicBase from '../episodic-base.entity';
import { Indexable } from '../indexable';
import { Taggable } from '../taggable';

export default class WrapBox
	extends EpisodicBase
	implements Indexable<WrapBoxESDoc>, Taggable {
	static deptId: DEPARTMENTS;

	static readonly deptNames: { [deptId: number]: string } = {
		1: 'Costume',
		5: 'Set Dec.',
		6: 'Props',
	};

	static readonly exportColumns = {
		NAME: 'name',
		DESCRIPTION: 'description',
		STORAGE_LOCATION: 'storage_location_id',
		DEPT: 'department',
	};

	static sortColumns = [
		'name',
		'description',
		'storage_location_id',
		'dept_id',
	];

	static searchColumns = ['name', 'description'];

	@Column('int')
	picture_id: number;

	@Column('varchar')
	name: string;

	@Column('varchar')
	description: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	@Column('int')
	storage_location_id: number;

	@Column('varchar')
	pallet: string;

	quantity_of_items: number;
	department: DEPARTMENTS;

	static rules() {
		return {
			...super.rules(),
			date_created: Joi.date().allow(null),
			department: Joi.number().integer(),
			description: Joi.string().max(1000).allow(null, ''),
			last_updated_time: Joi.date().allow(null),
			mobile_id: Joi.string().max(36).allow(null, ''),
			name: Joi.string().max(100),
			picture_id: Joi.number().integer().allow(null),
			quantity_of_items: Joi.number().integer().allow(null),
			storage_location_id: Joi.number().integer().allow(null),
			pallet: Joi.string().max(255).allow(null, ''),
		};
	}

	get complexId(): string {
		return `${this.department}.${this.id}`;
	}

	assign(props?: GenPartial<WrapBox>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<WrapBox>) {
		super(props);

		if (props) {
			if (typeof props.quantity_of_items !== 'undefined') {
				this.quantity_of_items = Number(props.quantity_of_items);
			}
			if (typeof props.department !== 'undefined') {
				this.department = Number(props.department);
			}
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	toESDoc() {
		return {
			id: this.id,
			episodic_id: this.episodic_id,
			name: this.name,
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			date_created: this.date_created,
			department: this.department,
			description: this.description,
			last_updated_time: this.last_updated_time,
			name: this.name,
			picture_id: this.picture_id,
			quantity_of_items: this.quantity_of_items,
			storage_location_id: this.storage_location_id,
			pallet: this.pallet,
		};
	}

	getTagName() {
		return this.name;
	}
}
